<template>
	<BaseCmsRotator :fetch="{code: 'benefits', limit: 6, response_fields: ['id','link','url_without_domain','link_target_blank','image_upload_path','title']}" v-slot="{items}">
		<div v-if="items?.length" class="benefits">
			<div class="wrapper-benefits">
				<BaseUiSwiper
					name="benefits"
					:options="{
							rewind: true,
							slidesPerView: 2,
							autoplay: {
								delay: 5000,
								disableOnInteraction: true
							},
							navigation: {
								enabled: false
							},
							breakpoints: {
								980: {
									slidesPerView: 6,
									enabled: false,
								},
								760: {
									slidesPerView: 3,
								},
							}
						}">
					<BaseUiSwiperSlide v-for="item in items" :key="item.id" class="benefit">
						<NuxtLink v-if="item.url_without_domain" :to="item.url_without_domain" :target="item.link_target_blank == 1 ? '_blank' : null">
							<div v-if="item.image_upload_path" class="benefit-img"><BaseUiImage :src="item.image_upload_path" width="30" height="30" /></div>
							<div v-if="item.title" class="benefit-title">{{ item.title }}</div>
						</NuxtLink>
						<div v-else>
							<div v-if="item.image_upload_path" class="benefit-img"><BaseUiImage :src="item.image_upload_path" width="30" height="30" /></div>
							<div v-if="item.title" class="benefit-title">{{ item.title }}</div>
						</div>
					</BaseUiSwiperSlide>
				</BaseUiSwiper>
			</div>
		</div>
	</BaseCmsRotator>
</template>

<style lang="less" scoped>
	.benefits{
		position: relative; border: none; height: 60px;
		@media (max-width: @t){height: 49px;}
		:deep(.swiper){flex-grow: 1;}
		:deep(.swiper-wrapper){display: flex; align-items: center; justify-content: space-between;}
		@media (min-width: @m){
			:deep(.swiper-slide){width: auto!important;}
		}
		@media (max-width: @ms){
			:deep(.swiper-initialized .swiper-slide){display: block!important;}
		}
	}
	.wrapper-benefits {
		width: 1480px;
		margin: 0 auto;
		position: relative;

		@media (max-width: @l) {
			width: auto;
			margin: 0 70px;
		}
		@media (max-width: @t) {
			justify-content: unset;
			max-height: 49px;
			margin: 0;
		}
		@media (max-width: @ms) {
			min-height: 40px;
			max-height: 40px;
			padding: 6px 0;
		}
	}
	.swiper-container{
		@media (max-width: @t){
			padding: 0 30px;
		}
		@media (max-width: @m){
			padding: 0 20px; padding: 0; background: @white;
		}
	}
	.benefit {
		font-size: 14px;
		line-height: 1.2;
		padding: 15px 10px;
		color: @textColor;
		:deep(a) {
			display: flex;
			align-items: center;
			text-decoration: none;
			color: @textColor;
			position: relative;
			&:hover {
				color: @blue;
			}
		}

		@media (max-width: @t) {
			padding: 12px 10px;
			font-size: 13px;
			display: flex;
			justify-content: center;
			a:hover {
				color: @textColor;
				img {
					transform: none;
				}
			}
		}
		@media (max-width: @ms) {
			font-size: 12px;
			padding: 0 12px;
			display: block;
			&:not(:nth-child(-n+2)){display: none;}
			:deep(a) {
				display: flex;
				align-items: center;
				&:hover {
					color: @textColor;
				}
			}
		}
	}
	.benefit-img {
		display: flex;
		align-items: center;
		justify-content: center;
		width: 30px;
		height: 30px;
		margin-right: 10px;
		:deep(img) {
			width: auto;
			height: auto;
			max-width: 30px;
			max-height: 30px;
			display: block;
			.transition(all);
		}

		@media (max-width: @t) {
			width: 25px;
			height: 25px;
			:deep(img) {
				max-width: 25px;
				max-height: 25px;
			}
		}
		@media (max-width: @ms) {
			width: 22px;
			height: 22px;
			margin: 0 7px 0 0;
			:deep(img) {
				max-width: 22px;
				max-height: 22px;
				.transition(none);
			}
		}
	}
</style>
